import axios from 'axios'

const Axios = axios.create({
  baseURL: 'https://api.airtable.com/v0/appKm06fM103Z9fGg/Courses'
})

const airtableAPIKey = process.env.VUE_APP_AIRTABLEKEY
Axios.defaults.headers.common = { Authorization: 'Bearer ' + airtableAPIKey }

export default {
  getCourses () {
    return Axios.get('?')
  },
  getCourse (slug) {
    return Axios.get("?filterByFormula={slug}='" + slug + "'")
  }
}
